// ============================================================
// L'ACHAT ET LA REVENTE SONT DEUX NOMBRES, ET ILS SE DISENT.
// ------------------------------------------------------------
// Trouvé le 8 septembre 2026 en regardant l'écran : la carte géométrie
// affichait « Coût matière : 213,56 € » et la synthèse « Matière :
// 234,92 € ». Les deux sont justes — c'est l'achat et la revente, à
// 10 % près (le coefficient matière du §6) — mais elles portaient LE
// MÊME NOM, et le §6 réserve « coût matière » au second.
//
// Deux nombres sous un seul mot se lisent comme une erreur. Nommés, ils
// se lisent comme une décision, et le coefficient se règle juste à côté.
//
// ── POURQUOI CETTE FONCTION EST PURE ET HORS DE L'ÉCRAN ──
//
// « Une règle d'affichage qu'on ne peut pas tester parce qu'elle est
// enfermée dans un composant n'est pas testée » — l'en-tête de
// `titreOperation.js`, et la raison pour laquelle ce défaut a vécu si
// longtemps : il se voyait à l'œil et dans aucun test.
// ============================================================

const nombre = (v) => (Number.isFinite(Number(v)) && v !== null && v !== '' ? Number(v) : null);

/**
 * Ce qu'il faut dire sous l'achat matière — ou rien.
 *
 * @returns {{montant: number|null, raison: string|null, texte: string|null}|null}
 *   `null` quand il n'y a RIEN à réconcilier : répéter le même chiffre
 *   sous lui-même n'apprend rien et alourdit chaque pièce.
 */
export function ecartOffre(mat = {}, detail = null) {
  // Fournie par le client : l'offre ne porte rien. C'est une
  // information, pas un écart de coefficient — et elle vaut d'être dite,
  // parce qu'un achat affiché sans ligne d'offre se lirait comme un
  // oubli.
  if (mat?.fournie_par_client) {
    return { montant: null, raison: null, texte: 'Fournie par le client : rien sur l’offre.' };
  }

  const offre = nombre(detail?.ligne_matiere);
  const achat = nombre(mat?.cost_total);
  if (offre == null || achat == null) return null;
  // Moins d'un centime d'écart : les deux nombres sont le même.
  if (Math.abs(offre - achat) < 0.005) return null;

  // Un montant RETENU à la main part tel quel sur l'offre : il ne se
  // justifie pas par un coefficient, il se justifie par quelqu'un.
  const coef = nombre(detail?.coefficient_matiere);
  const raison = mat?.montant_retenu != null
    ? 'montant retenu à la main'
    : (coef != null && coef !== 1 ? `× ${String(coef).replace('.', ',')}` : null);

  return { montant: offre, raison, texte: null };
}

export default ecartOffre;
